<template>
  <div class="classroom el-col-24">
    <Header></Header>
    <!--    <div class="main el-col-20 el-col-offset-2">-->
    <div class="main el-col-24 el-col-offset-0">
      <!--      菜单-->
      <div class="bookBox">
        <!--        选择教材-->
        <div class="menu_book">
          <span>{{ book.Name }}</span>
          <img
            @click="openChangeBook"
            src="@/assets/images/changeBook.png"
            alt=""
            class="change_btn"
          />
        </div>
        <!-- 单元/章节列表 -->

        <div class="menu_box" style="margin-bottom: 30px;">
          <el-menu
            default-active="0"
            @open="handleOpen"
            @close="handleClose"
            text-color="#FFFFFF"
            active-text-color="#5f90ff"
            background-color="#47474d"
            :unique-opened="true"
          >
            <!-- 动态生成的菜单项 -->
            <el-submenu
              v-for="(chpItem, chpIndex) in book.chapterList"
              :key="chpIndex"
              :index="chpIndex.toString()"
              @click.native.stop="selChapter(chpIndex, chpItem)"
            >
              <template slot="title">
                <span>{{ chpItem.Name }}</span>
                <span class="aside" v-if="chpItem.UserId == UserId">
                  <el-button
                    type="text"
                    icon="el-icon-edit"
                    @click.native.stop="editChapter(book.chapterList, chpItem)"
                    style="color: #fff"
                  ></el-button>
                  <el-button
                    type="text"
                    icon="el-icon-delete"
                    @click.native.stop="delChapter(chpIndex)"
                    style="color: #fff; margin: 0 3px"
                  ></el-button>
                </span>
              </template>
              <!-- 遍历子菜单项，根据是否有Children来决定渲染submenu还是menu-item -->
              <div
                v-for="(secItem, secIndex) in chpItem.Children"
                :key="secIndex"
              >
                <!-- 如果是submenu，需要定义title和内部的menu-item -->
                <template v-if="secItem.Children && secItem.Children.length">
                  <el-submenu
                    :index="`${chpIndex}-${secIndex}`"
                    @click.native.stop="selSection(chpIndex, secIndex, secItem)"
                  >
                    <template slot="title">
                      <i class="el-icon-document"></i>
                      <span>{{ secItem.Name }}</span>
                      <span class="aside" v-if="secItem.UserId == UserId">
                        <el-button
                          type="text"
                          icon="el-icon-edit"
                          @click="editChapter(chpItem, secItem, 1)"
                          style="color: #fff"
                        ></el-button>
                        <el-button
                          type="text"
                          icon="el-icon-delete"
                          @click="delSection(chpIndex, secIndex)"
                          style="color: #fff; margin-left: 3px"
                        ></el-button>
                      </span>
                    </template>
                    <el-menu-item
                      v-for="(subItem, subIndex) in secItem.Children"
                      :key="subIndex"
                      :index="`${chpIndex}-${secIndex}-${subIndex}`"
                      @click.native.stop="
                        selSubSection(
                          chpIndex,
                          secIndex,
                          subIndex,
                          secItem,
                          subItem
                        )
                      "
                    >
                      <span>{{ subItem.Name }}</span>
                      <span class="aside" v-if="subItem.UserId == UserId">
                        <el-button
                          type="text"
                          icon="el-icon-edit"
                          @click="editChapter(secItem, subItem, 2)"
                          style="color: #fff"
                        ></el-button>
                        <el-button
                          type="text"
                          icon="el-icon-delete"
                          @click="delSubSection(chpIndex, secIndex, subIndex)"
                          style="color: #fff; margin-left: 3px"
                        ></el-button>
                      </span>
                    </el-menu-item>
                    <el-menu-item
                      :index="`${chpIndex}-${secIndex}-add1`"
                      v-if="secItem.UserId === UserId"
                      @click.native.stop="editChapter(secItem, null, 2)"
                    >
                      <span class="addbox"
                        ><i class="icon el-icon-plus"></i> 添加小节</span
                      >
                    </el-menu-item>
                  </el-submenu>
                </template>

                <!-- 如果没有下一级，直接显示内容 -->
                <template v-else-if="secItem.UserId === UserId">
                  <el-submenu
                    :index="`${chpIndex}-${secIndex}`"
                    @click.native.stop="selSection(chpIndex, secIndex, secItem)"
                  >
                    <template slot="title">
                      <i class="el-icon-document"></i>
                      <span>{{ secItem.Name }}</span>

                      <span class="aside">
                        <el-button
                          type="text"
                          icon="el-icon-edit"
                          @click="editChapter(chpItem, secItem, 1)"
                          style="color: #fff"
                        ></el-button>
                        <el-button
                          type="text"
                          icon="el-icon-delete"
                          @click="delSection(chpIndex, secIndex)"
                          style="color: #fff; margin-left: 3px"
                        ></el-button>
                      </span>
                    </template>
                    <el-menu-item
                      :index="`${chpIndex}-${secIndex}-add2`"
                      v-if="secItem.UserId === UserId"
                      @click.native.stop="editChapter(secItem, null, 2)"
                    >
                      <span class="addbox"
                        ><i class="icon el-icon-plus"></i> 添加小节</span
                      >
                    </el-menu-item>
                  </el-submenu>
                </template>
                <template v-else>
                  <el-menu-item
                    :index="`sec-${chpIndex}-${secIndex}`"
                    @click.native.stop="selSection(chpIndex, secIndex, secItem)"
                  >
                    <i class="el-icon-document"></i>
                    <span>{{ secItem.Name }}</span>
                    <span class="aside" v-if="secItem.UserId == UserId">
                      <el-button
                        type="text"
                        icon="el-icon-edit"
                        @click="editChapter(chpItem, secItem, 1)"
                        style="color: #fff"
                      ></el-button>
                      <el-button
                        type="text"
                        icon="el-icon-delete"
                        @click="delSection(chpIndex, secIndex)"
                        style="color: #fff; margin-left: 3px"
                      ></el-button>
                    </span>
                  </el-menu-item>
                </template>
              </div>
              <el-menu-item
                :index="`sec-${chpIndex}-add`"
                v-if="chpItem.UserId === UserId"
                @click="editChapter(chpItem, null, 1)"
              >
                <!--自创建教材课本添加章/单元-->
                <span class="addbox">
                  <i class="icon el-icon-plus"></i> 添加小节</span
                >
              </el-menu-item>
            </el-submenu>
            <el-menu-item
              index="chp-add"
              v-if="book.UserId === UserId"
              @click="editChapter(book, null)"
            >
              <!--自创建教材课本添加章/单元-->
              <span class="addbox">
                <i class="icon el-icon-plus"></i> 添加单元章节</span
              >
            </el-menu-item>
          </el-menu>
        </div>
        <div style="position: fixed;bottom: 5px;width: 320px;color: #8d8b8b;">一板通智慧纸笔数字教育系统 1.0</div>
      </div>
      <!--      课堂列表-->
      <!--      <div ref="element" class="content el-col-18 el-col-offset-5">-->
      <div ref="element" class="content el-col-20">
        <keep-alive>
          <router-view @toParent1="selSection" @toParent="selChapter" />
        </keep-alive>
      </div>
      <!--      切换教材弹窗-->
      <el-dialog
        class="tk"
        title="请选择课本"
        :visible.sync="centerDialogVisible"
        width="60%"
        center
      >
        <el-select
          @change="changeSubject"
          v-model="condition.subject.ID"
          class="el-col-6 el-col-offset-2"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in subjects"
            :key="index"
            :label="item.Name"
            :value="item.ID"
          >
          </el-option>
        </el-select>
        <el-select
          @change="changeEdition"
          v-model="condition.edition.EditionID"
          class="el-col-7 el-col-offset-1"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in editions"
            :key="index"
            :label="item.Name"
            :value="item.EditionID"
          >
          </el-option>
        </el-select>
        <el-select
          @change="changeBook"
          v-model="condition.book.ID"
          class="el-col-5 el-col-offset-1"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in books"
            :key="index"
            :label="item.Name"
            :value="item.ID"
          >
            <!--自定义课本教材下拉选项，自创建的选项样式不一样并有操作按钮-->
            <span style="float: left">{{ item.Name }}</span>
            <span
              v-if="item.UserId === UserId"
              style="float: right; color: #8492a6; font-size: 13px; margin-left: 30px"
            >
              <el-button
                type="text"
                icon="el-icon-edit"
                @click="editBook(index)"
              ></el-button>
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="delBook(index)"
              ></el-button>
            </span>
          </el-option>
          <el-option value="">
            <el-button icon="el-icon-plus" @click="editBook(-1)" type="text"
              >创建新课本</el-button
            >
          </el-option>
        </el-select>
        <div class="tk_bottom"></div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="loadBookData">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";

export default {
  name: "Classroom",
  data() {
    return {
      UserId: "",
      condition: {
        subject: {
          ID: 0,
          Name: "",
          EnglishName: ""
        }, //选中的第一级学科
        edition: {
          Name: "",
          EditionID: 0
        }, //选中的第二级教材版本
        book: {
          ID: 0,
          Name: ""
        } //选中的第三级教材课本
      },
      query: {},
      // 联动start
      subjects: [], //第一级学科数组

      editions: [], //第二级教材版本数组

      books: [], //第三级教材课本数组

      book: {
        ID: 0,
        Name: "",
        Finish: 0, //0新教材，1已有教材
        EditionID: 0,
        SubjectId: 0,
        UserId: "",
        chapterList: [] //章列表
      }, //选中的教材课本的名称
      //bookType: 0, //选中的教材/课本类型（0平台基础库教材or1自建教材）
      centerDialogVisible: false, //选书弹框
      // 联动end

      chapterLevel: 1, //选中的是章还是节：1章，2节，3小节
      ChapterID: 0 //菜单id
      //goChapterID: "",
    };
  },
  mounted() {
    this.autoLogin();
  },
  methods: {
    // 自动登录
    autoLogin() {
      let that = this;
      if (localStorage["token"]) {
        this.UserId = localStorage["TeacherID"];

        this.axios
          .get(window.url + "GetTeachingMaterialForTeacher")
          .then(res => {
            if (res.data.result !== 200) {
              that.$error({
                title: "错误提示",
                content: res.data.message
              });
              return;
            }
            let userbook = res.data.data;
            //console.log("教师选中的教材", userbook);
            let id = 0;
            let sid = 0;
            let uid = "";
            let sname = "";

            if (userbook != null) {
              id = userbook.BookID;
              sid = userbook.SubjectID;
              sname = userbook.SubjectName;
              this.condition.subject = {
                ID: sid,
                Name: sname,
                EnglishName: ""
              };
              this.condition.edition = {
                EditionID: userbook.EditionID,
                Name: userbook.EditionName
              };
              this.condition.book = {
                ID: userbook.BookID,
                Name: userbook.BookName
              };
              //console.log(this.condition);

              uid = userbook.UserID;

              localStorage["subjectID"] = userbook.SubjectID;
              localStorage["editionID"] = userbook.EditionID;
              localStorage["bookID"] = userbook.BookID;
              localStorage["v1"] = sname;
              localStorage["v2"] = userbook.EditionName;
              localStorage["v3"] = userbook.BookName;
            }

            //console.log(that.book, id);

            if (id) {
              //console.log(window.url + "GetBookInfo?id=" + id);

              this.axios.get(window.url + "GetBookInfo?id=" + id).then(res => {
                if (res.data.result != 200) {
                  that.$message.error(`CRL001|${res.data.message}`);
                  return;
                }
                // console.log("******GetBookInfo", res.data);
                let book = res.data.data;
                if (book) {
                  // console.log("GetBookInfo,获取教材信息,book=", book);
                  that.book.ID = book.ID;
                  that.book.Name = book.Name;
                  that.book.SubjectId = sid;
                  that.book.SubjectName = sname;
                  that.book.EditionID = book.EditionID;
                  that.book.UserId = book.UserId;

                  // console.log("GetBookInfo,获取教材信息,that.book", that.book);
                  /* console.log(
                    "GetBookInfo,获取教材信息,book===that.book",
                    that.book === book
                  ); */

                  this.axios
                    .get(window.url + `GetNewBookChapterList?BookID=${book.ID}`)
                    .then(res => {
                      //console.log("******that4", that, that);
                      if (res.data.result != 200) {
                        that.$message.error(`CRL002|${res.data.message}`);
                        return;
                      }
                      let chps = res.data.data;
                      /* console.log(
                        "GetNewBookChapterList,获取教材章节详情",
                        chps
                      ); */

                      that.book.chapterList = chps;
                      // console.log("章节列表", that.book.chapterList);
                      //that.store.state.chapterList = chps;
                      // that.goChapterID = that.book.chapterList? that.book.chapterList[0]? that.book.chapterList[0].Children[0].ID: "": "";
                      // that.store.state.goChapterID = that.goChapterID;
                    });
                } else {
                  /* console.log(
                    "GetBookInfo,未能获取教材信息| GetBookInfo?id=" + id
                  ); */
                }
              });

              // console.log("condition", that.condition);

              /* that.axios.post(window.url + 'GetQCatList', {
                    Type: 3,
                    pid: that.book.ID
                  }).then(res => {
                    //console.log("获取后三级",res);

                  }).catch(error => {
                    // that.$message.error('您的网络开小差了！')
                  }); */
            } else {
              that.centerDialogVisible = true;
              this.axios
                .get(window.url + "GetNewBookSubject")
                .then(res => {
                  let data = res.data;
                  // console.log("获取后一级", data);
                  if (data.result != 200) {
                    that.$message.error(`CRL003|${data.message}`);
                    return;
                  }
                  that.subjects = data.data;
                })
                .catch(error => {
                  // that.$message.error('您的网络开小差了！')
                });
            }
            // console.log("that.book", that.book);
          });
      } else {
        //console.log("没有boken,跳到登录页.");
        that.$router.replace({
          name: "Login"
        });
      }
    },

    // 切换教材
    openChangeBook() {
      // 切换教材的相关信息
      // console.log("切换教材", this.condition.subject, this.condition.edition);

      var that = this;

      // 显示对话框
      this.centerDialogVisible = true;

      // 发起GET请求获取新的教材科目
      this.axios
        .get(window.url + "GetNewBookSubject")
        .then(res => {
          var data = res.data;
          if (data.result != 200) {
            that.$message.error(`CRR001|${data.message}`);
            return;
          }
          // 将获取到的科目数据赋值给subjects
          this.subjects = data.data;

          // 获取到的所有科目数据
          // console.log("-->获取所有科目", this.condition.subject, this.subjects);

          // 调用changeSubject方法获取所有科目
          this.changeSubject(this.condition.subject.ID, true);
        })
        .catch(error => {
          // 捕获错误，这里原本有显示网络错误的代码，但已被注释掉
          // that.$message.error('您的网络开小差了！')
        });
    },
    //选择学科, 如语文,数学,英语
    changeSubject(id, flag) {
      // console.log("选择科目：", id, flag);
      // 遍历列表找出科目英文名
      if (flag) {
        console.log("首次载入", flag);
      } else {
        this.condition.edition.EditionID = "";
        this.condition.book.ID = "";
      }
      let ename = "";
      this.subjects.some(item => {
        // 如果找到匹配的科目
        let name = item.Name;
        if (item.ID === id) {
          ename = item.EnglishName;
          this.condition.subject.ID = item.ID;
          this.condition.subject.Name = name;
          this.condition.subject.EnglishName = ename;
          localStorage["v1"] = name; //跨页面传递数据到备课页面
          localStorage["subjectID"] = item.ID;
          // console.log("科目已选中：", name, ename);
          return true;
        }
        // 如果没有找到匹配的科目，则返回false以继续遍历
        return false;
      });

      // console.log("载入已选择科目：", ename);

      this.axios
        .get(window.url + `GetNewBookEdition?SubEnglishName=${ename}`)
        .then(res => {
          var data = res.data;
          if (data.result != 200) {
            this.$message.error(data.message);
            return;
          }

          this.editions = data.data;
          /* console.log(
            `-->获取【${this.condition.subject.Name}】的版本列表：`,
            this.editions
          ); */
          if (flag) {
            this.changeEdition(this.condition.edition.EditionID, flag);
          } else {
            this.books = [];
          }
        })
        .catch(error => {
          that.$message.error("您的网络开小差了！");
        });
    },

    //选择版本, 如北师大,鲁教 ..
    changeEdition(eid, flag) {
      // 打印获取的版本和标志
      // console.log("获取指定科目的版本列表", eid, flag);

      // 根据flag的值进行判断
      if (!flag) {
        // 如果flag为false，则重置this.condition.book对象
        this.condition.book = {
          ID: "",
          Name: "请选择"
        };
      }

      // 遍历this.editions数组
      this.editions.some((item, index) => {
        // 打印当前遍历到的版本信息
        //console.log("版本", index, item.EditionID, this.condition.edition.EditionID);

        // 如果当前遍历到的版本ID与传入的ID相等
        if (item.EditionID === eid) {
          let name = item.Name;

          this.condition.edition.EditionID = eid;
          this.condition.edition.Name = name;

          // 打印已选中的版本名称
          // console.log("-->版本已选中：", name);

          // 将已选中的版本名称保存到localStorage的"v2"键下
          localStorage["v2"] = name;

          localStorage["editionID"] = item.EditionID;

          // 找到匹配项后返回true，中断遍历
          return true;
        }

        // 如果当前项不匹配，则返回false，继续遍历
        return false;
      });

      var that = this;

      // 发送GET请求获取教材的版本列表
      this.axios
        .get(
          window.url +
            `GetNewBookList?EditionID=${eid}&SubEnglishName=${
              this.condition.subject.EnglishName
            }`
        )
        .then(res => {
          var data = res.data;
          // console.log("请求获取教材指定版本的年级列表", data);

          if (data.result != 200) {
            that.$message.error(`CRR002|${data.message}`);
            return;
          }

          // 更新教材的列表信息
          this.books = data.data;

          // console.log("-->获取指定科目和版本的年级教材：", this.books);

          // 调用changeBook方法更新年级信息
          this.changeBook(this.condition.book.ID, true);
        })
        .catch(error => {
          // 捕获错误，此处注释掉了显示网络错误信息的代码
          // that.$message.error('您的网络开小差了！')
        });
    },

    /**
     * 根据传入的id和标志位修改教材信息
     *
     * @param {string} id 教材编号
     * @param {boolean} flag 是否选择年级的标志位，true表示已选择年级，false表示未选择年级
     */
    changeBook(id, flag) {
      // console.log("年级教材已选中", id, flag);
      //默认加载
      if (flag) {
        id = this.condition.book.ID;
      } else {
        this.condition.book.ID = "";
      }
      // console.log("当前用户编号：", this.UserId);
      this.books.some(item => {
        //console.log("用户编号,年级教材编号：", this.UserId, item.UserId);
        if (item.ID === id) {
          localStorage["v3"] = item.Name;
          localStorage["bookID"] = item.ID;
          this.condition.book = {
            ID: item.ID,
            Name: item.Name
          };
          return;
        }
      });
    },

    //确认 语文/北师大/七年级
    loadBookData() {
      let ID = this.condition.book.ID;

      //console.log("哈哈");
      // console.log("已切换教材，book.ID=", ID, this.books);
      if (!ID) {
        this.$alert("您还没有选择教材", "提示");
        return;
      }

      this.books.some(book => {
        if (book.ID === ID) {
          // console.log("已选中该年级的图书", book);
          this.book.ID = book.ID;
          this.book.Name = book.Name;
          this.book.EditionID = book.EditionID;
          this.book.UserId = book.UserId;
          this.book.Finish = book.finish;
          this.book.SubjectId = this.condition.subject.ID;
          return true; // 找到匹配项，终止遍历
        }
        return false;
      });

      localStorage.setItem("book", this.book);

      let that = this;
      //保存选择的教材
      this.axios
        .post(window.url + "SaveTeachingMaterialForTeacher", {
          bookID: ID,
          editionID: this.condition.edition.EditionID,
          subjectID: this.condition.subject.ID
        })
        .then(res => {
          // console.log("保存教师选择的教材", res);
          let data = res.data;
          if (data.result !== 200) {
            this.$message.error(data.message);
            return;
          }
          this.centerDialogVisible = false; //关闭窗口.
        });

      //获取后三级.
      this.axios
        .get(window.url + `GetNewBookChapterList?BookID=${ID}`)
        .then(res => {
          // console.log(res);
          var data = res.data;
          if (data.result !== 200) {
            that.$message.error(`CRR003|${data.message}`);
            // console.log(data.result);
            return;
          }
          var arr = data.data;

          //章节menu处理完毕
          /* console.log(
            "之前的章节列表,this.book.chapterList=",
            this.book.chapterList
          ); */
          this.book.chapterList = arr;
          /* console.log(
            "新的章节列表,this.book.chapterList=",
            this.book.chapterList
          ); */
          // console.log("当前用户：", this.UserId);
          //this.store.state.chapterList = arr;

          // if (this.book.chapterList.length > 0) {
          //   this.selChapter(0, this.book.chapterList[0]);
          //   this.store.state.Name = this.book.chapterList[0].Name;
          // }
        })
        .catch(error => {
          // that.$message.error('您的网络开小差了！');
        });
    },

    selChapter(chpIndex, chpItem) {
      // console.log("selChapter", chpIndex);
      // console.log("selChapter,book", this.book);
      this.chapterLevel = 1;

      /* if (this.book.chapterList[chpIndex].data.length == 0) { */
      if (chpItem) {
        localStorage["v4"] = chpItem.Name;
        localStorage["v5"] = chpItem.Name;
      }

      let query = {
        id: chpItem.ID,
        name: chpItem.Name,
        chapterLevel: this.chapterLevel,
        subjectID: this.book.SubjectId, //# UNDO SubjectId找不到
        bookID: this.book.ID,
        editionID: this.book.EditionID //# UNDO EditionID找不到
      };
      // console.log("query", query);
      this.$router
        .push({
          name: "Detail",
          query
        })
        .catch(err => {
          if (err.name !== "NavigationDuplicated") {
            // 处理非NavigationDuplicated错误
            throw err;
          }
          // 处理或忽略NavigationDuplicated错误
        });
      /* } */
    },

    selSection(index, index1, chpItem) {
      let chp = this.book.chapterList[index];
      // console.log(
      //   "selSection",
      //   index,
      //   index1,
      //   chpItem.Name,
      //   chpItem.ID,
      //   chp.Children.length
      // );
      // console.log("selSection,book", this.book);

      this.chapterLevel = 2;

      // 样式
      if (chp.Children.length > 0) {
        // localStorage["v4"] = chp.Name;
        // localStorage["v5"] = chp.Children[index1].Name;

        // 交互;
        this.ChapterID = chpItem.ID;
        let query = {
          id: this.ChapterID,
          name: chpItem.Name,
          chapterLevel: this.chapterLevel,
          subjectID: this.book.SubjectId,
          bookID: this.book.ID,
          editionID: this.book.EditionID
        };
        //console.log("query", this.query, query);
        if (this.query !== query) {
          this.query = query;
          this.$router
            .replace({
              name: "Detail",
              query
            })
            .catch(err => {
              if (err.name !== "NavigationDuplicated") {
                // 处理非NavigationDuplicated错误
                throw err;
              }
              // 处理或忽略NavigationDuplicated错误
            });
        }
      }
    },

    selSubSection(index, index1, index2, secItem, subItem) {
      //console.log("selSubSection", index, index1, index2, secItem, subItem);
      //console.log("selSubSection,book", this.book);
      let that = this;
      let arr = this.book.chapterList;
      this.chapterLevel = 3;

      // 样式
      if (arr[index].Children.length > 0) {
        localStorage["v4"] = secItem.Name;
        localStorage["v5"] = subItem.Name;
      }
      // 交互;
      that.ChapterID = subItem.ID;
      this.$router
        .replace({
          name: "Detail",
          query: {
            id: that.ChapterID,
            name: subItem.Name,
            chapterLevel: this.chapterLevel,
            subjectID: this.book.SubjectId,
            bookID: this.book.ID,
            editionID: this.book.EditionID
          }
        })
        .catch(err => {
          if (err.name !== "NavigationDuplicated") {
            // 处理非NavigationDuplicated错误
            throw err;
          }
          // 处理或忽略NavigationDuplicated错误
        });
    },

    /**
     * 编辑教材信息
     *
     * @param bookIndex 书籍索引，如果是新增书籍则为-1
     */
    editBook(bookIndex) {
      let book = null;
      //判断是添加新课本还是编辑课本
      if (bookIndex != -1) {
        book = this.books[bookIndex];
      } else {
        book = {
          EditionID: this.condition.edition.EditionID,
          EditionName: this.condition.edition.Name,
          SubEnglishName: this.condition.subject.EnglishName,
          SubjectID: this.condition.subject.ID,
          SubjectName: this.condition.subject.Name,
          UserId: this.UserId
        };
      }
      let that = this;
      // console.log("编辑教材", bookIndex, book, this.condition);

      //打开编辑框
      this.$prompt("请输入课本名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: book != null && book.ID ? book.Name : ""
      })
        .then(({ value }) => {
          // //提交新课本的保存，并追加数据
          // let pid = that.condition.edition.EditionID;
          //let id = book != null && book.ID ? book.ID : "";

          const name = value;
          book.Name = name;

          // console.log("待保存的图书：", book);
          this.axios.post(window.url + "SaveBookForTeacher", book).then(res => {
            // console.log("保存图书成功", res);
            var data = res.data;
            if (data.result == 200) {
              //正常数据
              let id = data.data;
              if (bookIndex == -1) {
                book.ID = id;
                that.books.push(book);
              } else {
                book.Name = name;
              }
              that.condition.book.ID = id;
              that.condition.book.Name = name;
              // console.log("新书：", id, book);
            } else {
              that.$message.error(`CRU001|${data.message}`);
            }
          });
        })
        .catch(() => {
          //取消编辑
        });
    },

    /**
     * 编辑章节
     *
     * @param {number} chpIndex - 章节索引
     * @param {object} chapter - 章节对象
     * @returns {void}
     */
    editChapter(parentchp, chapter, rootlevel = 0) {
      /* console.log(
        "新增或修改单元章节| parentchp, chapter",
        parentchp,
        chapter,
        rootlevel
      ); */
      let addflag = chapter == null ? true : false;
      /* if (addflag) {
        console.log("新增", addflag);
      } else {
        console.log("修改", addflag);
      } */

      //打开编辑框
      this.$prompt("请输入单元章节名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: chapter != null ? chapter.Name : ""
      })
        .then(({ value }) => {
          const chpname = value;
          /* console.log(
            "提交新单元章节的保存，并追加数据",
            addflag,
            parentchp,
            chapter,
            rootlevel
          ); */
          //提交新单元章节的保存，并追加数据
          if (addflag) {
            // console.log("111");
            //判断是新增章还是节还是小节
            chapter = {
              Name: chpname,
              ID: "",
              PID: rootlevel > 0 ? parentchp.ID : "",
              BookID: this.condition.book.ID,
              UserId: this.UserId,
              Children: []
            };
            // console.log("111222", chapter);
          } else {
            chapter.Name = chpname;
            // console.log("000");
          }
          // console.log("===>>保存数据", chapter);

          this.axios
            .post(window.url + "SaveChapterForTeacher", chapter)
            .then(res => {
              var data = res.data;
              if (data.result === 200) {
                //获取新增的编号
                let id = data.data;
                // console.log("新章节编号：", id);
                if (addflag) {
                  chapter.ID = id;

                  if (rootlevel > 0) {
                    parentchp.Children.push(chapter);
                  } else {
                    parentchp.chapterList.push(chapter);
                  }
                }
                this.$alert("保存成功！", "提示", {
                  confirmButtonText: "确定"
                });
              } else {
                this.$message.error(data.message);
              }
            });
          // console.log("保存数据结束");
        })
        .catch(() => {
          //取消编辑
        });
    },

    /**
     * 删除课本
     *
     * @param {number} index - 要删除的课本在数组中的索引
     */
    delBook(index) {
      //弹删除确认对话框
      let that = this;
      let book = that.books[index];
      this.$confirm(
        `此操作将永久删除课本【${book.Name}】，是否继续吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        if (book) {
          //调删除接口，
          this.axios
            .post(window.url + "DeleteBookChapterForTeacher", {
              ID: book.ID
            })
            .then(res => {
              let data = res.data;
              if (data.result === 200) {
                //数据清除
                that.books.splice(index, 1);
                that.condition.book.ID = "";
              } else {
                that.$message.error(`CRD001|${data.message}`);
              }
            });
        } else {
          that.$message.error("CRD002|该课本不存在或已被删除");
        }
      });
    },

    delChapter(chpList, id, index) {
      //弹删除确认对话框
      let that = this;
      this.$confirm("此操作将永久删除该单元章节，是否继续吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        //调删除接口，
        this.axios
          .post(window.url + "DeleteBookChapterForTeacher", {
            ID: id
          })
          .then(res => {
            var data = res.data;
            if (200 == data.result) {
              //如果被删的单元章节已被选中，取消选择
              // if (that.goChapterID == id) {
              //   that.goChapterID = "";
              // }
              //数据清除
              chpList.splice(index, 1);
            } else {
              that.$message.error(`CRD003|${data.message}`);
            }
          });
      });
    },

    delSection(parentItem, id, index) {
      //弹删除确认对话框
      let that = this;
      this.$confirm("此操作将永久删除该小节，是否继续吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        //调删除接口，
        this.axios
          .post(window.url + "DeleteBookChapterForTeacher", {
            ID: id
          })
          .then(res => {
            var result = res.data;
            if (200 == result.result) {
              //如果被删的小节已被选中，取消选择
              // if (that.goChapterID == id) {
              //   that.goChapterID = "";
              // }
              //数据清除
              parentItem.Children.splice(index, 1);
            } else {
              that.$message.error(`CRD004|${data.message}`);
            }
          });
        //如果被删的小节已被选中，取消选择
        // if (this.goChapterID == this.book.chapterList[menuIndex].data[liIndex].id) {
        //   this.goChapterID = "";
        // }
        //数据清除
        this.book.chapterList[menuIndex].data.splice(liIndex, 1);
      });
    },

    delSubSection(secItem, subItem) {
      //弹删除确认对话框
      let that = this;
      this.$confirm("此操作将永久删除该小节，是否继续吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        //调删除接口，
        let id = subItem.ID;
        this.axios
          .post(window.url + "DeleteBookChapterForTeacher", {
            ID: id
          })
          .then(res => {
            var data = res.data;
            if (200 == data.result) {
              //如果被删的小节已被选中，取消选择
              // if (that.goChapterID == id) {
              //   that.goChapterID = "";
              // }
              //数据清除
              secItem.Children.splice(cIndex, 1);
            } else {
              that.$message.error(`CRD005|${data.message}`);
            }
          });
        //如果被删的小节已被选中，取消选择
        // if (
        //   this.goChapterID ==
        //   this.book.chapterList[menuIndex].data[liIndex].data[cIndex].id
        // ) {
        //   this.goChapterID = "";
        // }
        //数据清除
        this.book.chapterList[menuIndex].data[liIndex].data.splice(cIndex, 1);
      });
    },

    handleOpen(index, indexPath) {
      console.log("打开的菜单项:", index, indexPath);
      // 在这里添加你的逻辑
    },
    handleClose(index, indexPath) {
      // 在这里添加你的逻辑
      let arr = index.split("-");
      console.log("关闭的菜单项:", index, arr);
    }
  },
  components: {
    Header
  }
};
</script>

<style lang="less" scoped>
.el-dialog .el-dialog--center .el-dialog__body {
  padding: 0 !important;
  max-height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.el-radio__inner {
  border-color: #8a8a8a;
}
/deep/ .aside {
  position: absolute;
  right: 30px;
  .el-button {
    width: 25px;
    i {
      color: #fff;
    }
  }
}

.classroom {
  width: 100%;
  /*height: 100%;*/
  background-color: #ecedef;

  .main {
    background-color: #ffffff;
    /*margin-top: 70px;*/
    /*height: 100%;*/
    display: flex;

    .bookBox {
      color: #ffffff;
      background-color: #23232b;

      /*min-height: 900px;*/
      display: block;
      position: fixed;
      top: 70px;
      bottom: 0px;
      width: 320px;
      overflow: auto;

      .menu_box {
        .el-menu {
          color: #ffffff;
          background-color: #23232b !important;
          text-align: left;
          border-right: 0;

          > .el-submenu {
            border-bottom: solid 1px #000;
            > .el-submenu__title {
              font-size: 30px !important;
            }

            &.is-opened .el-submenu__title {
              color: #fff !important;
              background-color: #5f90ff !important;
            }

            .el-menu-item {
              border-top: solid 1px #000;
              background-color: #303039 !important;
              padding: 0px 20px !important;
              > .addbox {
                margin: 0px 5px;
                .icon {
                  margin-right: 5px;
                }
              }
            }
            /deep/ .el-submenu__title {
              height: 45px !important;
              line-height: 45px !important;
              padding: 0px 20px !important;

              .el-submenu__icon-arrow {
                font-size: 16px;
                color: #fff;
                right: 5px;
              }
            }
            > .el-menu {
              > div {
                > .el-submenu {
                  /deep/ .el-submenu__title {
                    height: 45px !important;
                    line-height: 45px !important;
                    border-top: solid 1px #000;
                    background-color: #303039 !important;
                    .el-icon-document {
                      margin: 0px;
                    }

                    .el-submenu__icon-arrow {
                      right: 5px;
                      font-size: 14px;
                    }
                  }
                  > .el-menu {
                    > .el-menu-item {
                      border-top: solid 1px #000;
                      background-color: #23232b !important;
                      > .el-icon-location {
                        margin: 0px 0px 0px 10px;
                      }
                      > span:first-child {
                        margin-left: 20px;
                      }
                    }
                  }
                }

                .el-menu-item {
                  height: 45px !important;
                  line-height: 45px !important;

                  .el-icon-document {
                    margin: 0px !important;
                  }

                  > .addbox {
                    margin: 0px 15px;
                    .icon {
                      margin-right: 7px;
                    }
                  }
                }
              }
            }
          }
          > .el-menu-item {
            height: 45px !important;
            line-height: 45px !important;
            .is-active {
              color: #fff !important;
              background-color: #5f90ff !important;
            }
            > .addbox {
              .icon {
                margin-right: 10px;
              }
            }
          }
        }
      }

      .menu_book {
        height: 70px;
        line-height: 70px;
        color: #ffffff;
        background-color: #23232b;
        text-align: left;
        position: relative;

        span {
          margin-left: 24px;
          display: block;
          height: 70px;
          line-height: 22px;
          padding: 15px 18px 15px 0;
        }

        .change_btn {
          position: absolute;
          right: 10px;
          bottom: 10px;
          font-size: 14px;
          height: 26px;
          cursor: pointer;
          line-height: 25px;
        }
      }

      .menu_unit {
        background-color: #47474d;
        height: 45px;
        line-height: 45px;
        cursor: pointer;
        font-size: 15px;
        text-align: left;
        border-bottom: 1px solid #000;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;

        .arrowhead {
          width: auto;
          position: absolute;
          top: 0;
          right: 0;
          margin-right: 15px;
          color: #d9d9d9;
        }

        span.name {
          width: 100%;
          box-sizing: border-box;
          -webkit-box-sizing: border-box;
          display: inline-block;
          padding-left: 15px;
          padding-right: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        span.create {
          width: 180px;
        }
      }

      .menu_unit_cover {
        background-color: #5f90ff;
      }

      .menu_ul {
        background-color: #23232b;
        color: #b4b4b4;
        font-size: 14px;
        .menu_ul_children {
          background-color: #23232b;
          color: #b4b4b4;
          font-size: 14px;
          .menu_ul_children_li {
            background-color: #1c1c1c;
            color: #b4b4b4;
            font-size: 14px;
          }
        }
        .menu_li {
          border-bottom: 1px solid #000;
          //height: 45px;
          line-height: 45px;
          cursor: pointer;
          text-align: left;
          position: relative;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          span.title {
            width: 260px;
            display: inline-block;
            margin-left: 40px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          span.title.create {
            width: 170px;
          }

          .icon-yuanquan {
            position: absolute;
            left: 18px;
          }
          span.arrowhead {
            width: auto;
            position: absolute;
            top: 0;
            right: 15px;
          }
        }

        .menu_li_cover {
          background-color: #5f90ff;
          color: #ffffff;
        }
      }
    }

    .content {
      flex: 1 1 auto !important;
      margin-top: 70px;
      padding-left: 340px;
      padding-right: 20px;
      min-height: 1100px;
    }

    .edit {
      /*height: 100%;*/
      margin-bottom: 20px;

      .content_title {
        margin-top: 20px;
        line-height: 40px;
        text-align: left;
        padding-left: 30px;
        font-size: 16px;
        font-weight: 600;
        position: relative;

        .icon-shu {
          position: absolute;
          left: 0;
          font-size: 24px;
          color: #59bf85;
        }
      }

      .title_top {
        margin-top: 20px;
        line-height: 50px;
        text-align: left;
        padding-left: 30px;
        font-size: 24px;
        font-weight: 600;
        position: relative;
        border-bottom: 2px solid #dedede;

        .icon-shu {
          position: absolute;
          left: 0;
          font-size: 28px;
          color: #59bf85;
        }
      }

      .biaoti {
        margin: 20px 0;
        height: 40px;
      }

      .bei_box {
        width: 100%;
        overflow: hidden;
        border: 1px solid #dedede;
        background-color: #ffffff;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;

        .beipipei {
          width: 100px;
          height: 35px;
          margin: 10px auto;
          cursor: pointer;
        }

        .bei_top {
          margin: 0 auto;
          width: 94%;
          text-align: left;

          .file_li {
            height: 40px;
            line-height: 40px;
            border-bottom: 1px dashed #dedede;

            .file_yx {
              display: inline-block;
              vertical-align: top;
              margin-right: 20px;
            }

            .file_icon {
              display: inline;
              background-color: #5f90ff;
              color: #ffffff;
              padding: 2px 4px;
              -webkit-border-radius: 3px;
              -moz-border-radius: 3px;
              border-radius: 3px;
            }

            .file_name {
              margin-right: 60px;
              max-width: 200px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .file_del {
              color: red;
              cursor: pointer;
              padding: 0 6px;
            }

            .file_down {
              color: #00be00;
              cursor: pointer;
              padding: 0 6px;
            }
          }
        }

        .bei_bottom {
          height: 60px;
          background-color: #f5f5f5;

          .btn_file {
            top: 15px;
            left: 30px;
            position: relative;
            cursor: pointer;
            background-color: #ffffff;
            display: block;
            height: 30px;
            line-height: 30px;
            width: 140px;
            text-align: center;
            -webkit-border-radius: 3px;
            -moz-border-radius: 3px;
            border-radius: 3px;
            -webkit-box-shadow: 0 0 1px 2px #dedede;
            -moz-box-shadow: 0 0 1px 2px #dedede;
            box-shadow: 0 0 1px 2px #dedede;

            .fileBtn {
              cursor: pointer;
              position: absolute;
              width: 100%;
              height: 100%;
              left: 0;
              top: 0;
              opacity: 0;
            }
          }

          .add {
            height: 40px;
            width: 40px;
            margin: 60px auto;
          }
        }
      }

      .imgs_box {
        .image {
          width: 100px;
          height: 80px;
          display: inline-block;
          vertical-align: top;
          text-align: left;
          margin: 20px 30px;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          border-radius: 5px;
          cursor: pointer;
        }
      }

      .zaixian {
        width: 180px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        cursor: pointer;
        border: 1px solid #dedede;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
      }

      .submit {
        width: 160px;
        height: 50px;
        cursor: pointer;
        margin-top: 50px;
        line-height: 50px;
        text-align: center;
        background-color: #149bd7;
        color: #ffffff;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
      }
    }

    .curriculum {
      .tableTitle {
        height: 70px;
        line-height: 70px;
        font-size: 22px;
        text-align: left;

        .icon-shu {
          color: #59bf85;
          font-size: 25px;
        }
      }

      .table {
        border: 1px solid #e3e5e7;
        margin: 0 auto;

        .pipeiImg {
          display: block;
          width: 100px;
          height: 34px;
          margin: 10px auto;
        }

        .thead {
          background-color: #f6f6f6;

          td {
            text-align: center;
          }
        }

        tr {
          cursor: pointer;

          td:nth-child(1) {
            text-align: left;
            text-indent: 2em;
          }
        }

        td {
          height: 44px;
          line-height: 44px;
        }
      }

      .block {
        margin-top: 20px;
      }

      .addClass {
        background-color: #149bd7ff;
        float: left;
        margin: 30px;
        padding: 6px 30px;
        color: #ffffff;
        cursor: pointer;
        font-size: 16px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
      }
    }

    .myDetail {
      text-align: left;

      .fileBox {
        width: 100%;
        margin: 30px auto;
        border: 1px solid #dedede;

        .fileLi {
          width: 200px;
          height: 200px;
          display: inline-block;
          margin: 20px;
          cursor: pointer;

          .fileTop {
            color: dodgerblue;
            border: 3px solid dodgerblue;
            text-align: center;
            width: 80px;
            height: 80px;
            line-height: 80px;
            font-size: 30px;
            margin: 30px auto;
          }

          .fileTitle {
            width: 100%;
            text-align: center;
            line-height: 30px;
            font-size: 18px;
          }
        }
      }

      .dataBox {
        width: 100%;
        height: 400px;
        border: 1px solid #dedede;

        .title {
          width: 100%;
          height: 60px;
          line-height: 60px;
          font-size: 20px;
          text-indent: 2em;
          border-bottom: 1px solid #dedede;
        }

        .echartBox {
          border-right: 1px solid #dedede;

          .echartC {
            height: 300px;
            width: 300px;
            margin: 10px auto;

            #echart {
              display: block;
            }
          }
        }

        .dataText {
          .dataText_content {
            text-indent: 2em;
            width: 90%;
            font-size: 16px;
            line-height: 30px;
            margin: 60px auto;
          }

          .dataText_bottom {
            width: 90%;
            margin: 0 auto;
            font-size: 20px;
          }
        }
      }
    }

    /*弹框*/

    .tk_bottom {
      width: 100%;
      height: 30px;
    }

    .el-radio {
      width: 100%;
      line-height: 40px;
      margin: 20px auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Classroom.vue